import React from "react";

const EllipsisHorizontal = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-EllipsisHorizontal"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-EllipsisHorizontal"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <circle cx="2" cy="12" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="22" cy="12" r="2" />
    </svg>
  );
};

export default EllipsisHorizontal;
